var _g, _path, _path2, _path3, _path4, _path5, _path6, _rect, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1AdjustableDesk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1048,
    viewBox: "0 0 1440 1048",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter0_f_1949_5804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M449 742L463.194 689H959.806L976 742H449Z",
    fill: "#23234B"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M430 609L458 486H940.753L972 609H430Z",
    fill: "url(#paint0_linear_1949_5804)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M430 609H972V615H430V609Z",
    fill: "#655E50"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M431 608.5H971.5",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M430 616H972",
    stroke: "#323048",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M496 760.5H474.5L487.5 698.5H502.5L504.5 692.5V698.5L496 760.5Z",
    fill: "#5D6081"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M496 754.5H474.5L487.5 692.5H504.5L496 754.5Z",
    fill: "#7A7C95"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 474,
    y: 754,
    width: 22,
    height: 7,
    fill: "#404262"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M481 618H500V721H481V618Z",
    fill: "#4A4861"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M501 713.5L500 721V617.5H501.5L501 713.5Z",
    fill: "#2A2D46"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M906 760.5H927.5L914.5 698.5H899.5L897.5 692.5V699.5L906 760.5Z",
    fill: "#5D6081"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M906 754.5H927.5L914.5 692.5H897.5L906 754.5Z",
    fill: "#7A7C95"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M928 754H906V761H928V754Z",
    fill: "#404262"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M920 618H901V721H920V618Z",
    fill: "#4A4861"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M900 710L901 721V617.5H899.5L900 710Z",
    fill: "#2A2D46"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M946.447 614.724L946.809 614H946H892.5H891.65L892.063 614.743L897.063 623.743L897.206 624H897.5H941.5H941.809L941.947 623.724L946.447 614.724Z",
    stroke: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M949.861 614.5H881.5L887.889 626H944.111L949.861 614.5Z",
    fill: "url(#paint1_linear_1949_5804)",
    stroke: "white",
    strokeOpacity: 0.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 892.221,
    cy: 620.109,
    r: 2.415,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 900.667,
    cy: 619.611,
    r: 1.91667,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 909.611,
    cy: 619.611,
    r: 1.91667,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 918.556,
    cy: 619.611,
    r: 1.91667,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 927.5,
    cy: 619.611,
    r: 1.91667,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 936.444,
    cy: 619.611,
    r: 1.91667,
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter1_f_1949_5804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M806.5 532.5H585L602 511H789.5L806.5 532.5Z",
    fill: "#1D1F45"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1949_5804",
    x: 441,
    y: 681,
    width: 543,
    height: 69,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_1949_5804"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1949_5804",
    x: 571,
    y: 497,
    width: 249.5,
    height: 49.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_1949_5804"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1949_5804",
    x1: 701,
    y1: 511,
    x2: 701,
    y2: 609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A39C90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A79B86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1949_5804",
    x1: 915.681,
    y1: 614.5,
    x2: 915.681,
    y2: 626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1AdjustableDesk);
export default __webpack_public_path__ + "static/media/1AdjustableDesk.9ea3bb1bdee8ca4194b6018635d73e74.svg";
export { ForwardRef as ReactComponent };